export default "__VITE_ASSET__DqLrXt2S__"